<template>
  <div>
    <iframe id="iframeReg" :src="urlTv"></iframe>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import iFrameResize from "iframe-resizer/js/iframeResizer"
import { mapActions } from "vuex"
export default {
  name: "region",
  props: {
    region: {
      type: String,
      required: true
    }
  },
  components: {},
  mounted() {
    this.isValidRegion()
    iFrameResize({ log: false }, "#iframeReg")
  },
  beforeCreate() {},
  methods: {
    ...mapActions("carrito", {
      limpiarCarrito: "limpiar"
    }),
    init() {
      this.limpiarCarrito()
      this.limpiarCarrito()
      this.setApp()
      this.$store.dispatch("app/setFormSave", null)
      this.$store.dispatch("app/setFormSaveTicket", null)
    },
    setApp() {
      this.$store.dispatch("app/saveApp", this.$route.meta.app)
    },
    isValidRegion() {
      const valido = this.regiones.some(r => r.key === this.region)
      if (!valido) {
        this.$router.push({ name: "inicio" })
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.init()
    })
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters("app", {
      app: "getApp",
      regiones: "getRegiones"
    }),
    urlTv: function() {
      return `https://allseasons.tourvector.com/${this.region}/`
    }
  },
  watch: {
    region: function(newVal, oldVal) {
      // watch it
      this.isValidRegion()
    }
  }
}
</script>
<style>
#iframeReg {
  border: 0;
  width: 100%;
  height: 500px;
}
</style>
